import React, { useEffect, useRef, useState } from 'react';
import './ProjectCustomization.css';

const PersonalizationProject = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); // Stop observing once animated
        }
      },
      {
        threshold: 0.1, // Trigger when 10% of the component is visible
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="personalization-section" ref={sectionRef}>
      <div className="header">
      <img className="icon"
              src="/images/customization_icon.png" />
        <div>
          <h1 className="title">Projet de personnalisation</h1>
          <p className="subtitle">
            Afin de mener votre projet en toute sérénité, nous vous guidons à travers les étapes suivantes :
          </p>
        </div>
      </div>

      <div className="steps-container">
        <div className={`step ${isVisible ? 'animate' : ''}`}>
          <div className="step-number primary">01</div>
          <h3 className="step-title">Choix des emballages</h3>
          <p className="step-description">
            Type d’emballage, qualité, dimensions, quantité, … dans le but d’établir un devis sur-mesure.
          </p>
        </div>

        <div className={`step ${isVisible ? 'animate' : ''}`}>
          <div className="step-number">02</div>
          <h3 className="step-title">Validation de votre devis</h3>
          <p className="step-description">
            Préparation de votre commande pour envoi à notre usine.
          </p>
        </div>

        <div className={`step ${isVisible ? 'animate' : ''}`}>
          <div className="step-number">03</div>
          <h3 className="step-title">Réception et préparation de votre marchandise</h3>
          <p className="step-description">
            Selon les conditions mentionnées dans votre devis (livraison totale/partielle, stockage …).
          </p>
        </div>
      </div>
    </section>
  );
};

export default PersonalizationProject;